export default __webpack_public_path__ + "static/media/IPAD.6c9df4e4.svg";